<template>
    <footer class="footer">
        <div class="container">
            <div class="row">
                <div class="col col-lg-3 col-md-12 mb-4 order-2 order-lg-1">
                    <div class="footer__brand">
                        <router-link :to="{name:'home'}">
                            <img src="../../assets/logo.svg" alt="ShelfSet" width="50" height="59">
                        </router-link>
                    </div>
                    <div class="footer__socials">
                        <a href="#">
                          <font-awesome-icon :icon="['fab', 'facebook-f']" />
                        </a>
                        <a href="#">
                          <font-awesome-icon :icon="['fab', 'twitter']" />
                        </a>
                        <a href="#">
                          <font-awesome-icon :icon="['fab', 'instagram']" />
                        </a>
                    </div>
                </div>
                <div class="col col-lg-7 col-md-8 col-12 order-1 order-lg-2">
                    <div class="row footer__links">
                        <div class="col col-md-4 col-6 footer__group">
                            <h4 class="footer__heading">Product</h4>
                            <ul>
                                <li>
                                    <a href="/#features" @click.prevent="navTo({name: 'home'})" v-scroll-to="'#features'">Features</a>
                                </li>
                                <li>
                                    <router-link :to="{name: 'planogram-automation-software'}">Planogram Automation</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'retail-execution-software'}">Retail Execution</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'shelf-image-recognition'}">Shelf Image Recognition</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'automatic-planogram-generation'}">Auto Planogram Generation</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'pos-fixture-reporting'}">POS Fixture Reporting</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'brand-logo-recognition'}">Brand Logo Recognition</router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="col col-md-4 col-6 footer__group">
                            <h4 class="footer__heading">Compare</h4>
                            <ul>
                                <li>
                                    <router-link :to="{name: 'compare-infilect'}">vs Infilect</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'compare-paralleldots'}">vs ParallelDots</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'compare-vispera'}">vs Vispera</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'compare-trax'}">vs Trax</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'compare-gospotcheck'}">vs GoSpotCheck</router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="col col-md-4 col-6 footer__group">
                            <h4 class="footer__heading">Company</h4>
                            <ul>
                                <li>
                                    <router-link :to="{name: 'about-us'}">About Us</router-link>
                                </li>
                                <li>
                                    <a href="/#contact" @click.prevent="navTo({name: 'home'})" v-scroll-to="'#contact'">Contact</a>
                                </li>
                                <li>
                                    <router-link :to="{name: 'blog'}">Blog</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'privacy'}">Privacy Policy</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'terms'}">Terms of Service</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col col-lg-2 col-md-4 col-12 order-3">
                    <div class="footer__contact">
                        <h4 class="footer__heading">Contact</h4>
                        <a href="mailto:info@shelfset.app">info@shelfset.app</a>
                        <a href="tel:+12012572569">+1-201-257-2569</a>
                    </div>
                </div>
                <div class="col col-12 pt-3 pb-2 order-4">
                    <small>&copy; Copyright ShelfSet LLC - {{current_year}}</small>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
    computed: {
        current_year(){
            return this.$moment().format('YYYY')
        }
    },
    methods: {
        navTo(route) {
            if (this.$route.name != route.name) return this.$router.push(route);
            return;
        }
    }
}
</script>